import BasicInput from '@shared/ui/forms/inputs/BasicInput';
import { teamNameRule } from '@utils/validation';
import { useTranslation } from 'react-i18next';

export default function TeamNameInput({ control, errors }) {
  const { t } = useTranslation();
  return (
    <BasicInput
      control={control}
      name="name"
      label={t('team_name')}
      placeholder={t('enter_team_name')}
      validation={teamNameRule}
      error={errors.name}
      counter
    />
  );
}
